import memoizee from 'memoizee';

export type RNWrapperMessageHeader = { key: string } & Record<string, unknown>;

const PROP = 'ReactNativeWebView';
const MESSAGE_SEPARATOR = '@LINQO-LCV-RN-MESSAGE@';

export const isReactNativeWrapperUncached = () => PROP in window;

export const postMessage = (
  message: string,
  options: RNWrapperMessageHeader
) => {
  window[PROP as any].postMessage(
    JSON.stringify(options) + MESSAGE_SEPARATOR + message
  );
};

export const isRnWrapper = memoizee(isReactNativeWrapperUncached);
